module.exports = __webpack_public_path__ + "static/media/homepage4.e89f5481.jpg";